import {mix} from "@spa/utils/assetPathResolver";
import {usePage} from "@inertiajs/react";
import {useState, useEffect} from "react";
import {createPortal} from "react-dom";
import JobAlertForm from "@spa/features/search_job/pc/components/list/JobAlertForm";
import {useJobAlert} from "@spa/features/search_job/pc/contexts/JobAlertContext";
import {replacePlaceholders} from "@spa/utils/textFormatter";

const JobAlert = ({ isInJobPanelList, translations }) => {
    const { route, translations: generalTranslations } = usePage().props;
    const { conditionString, isDoubleOptIn, isJobAlertSubmitSuccess } = useJobAlert();
    const jobAlertTranslations = translations.job_alert;
    
    // スナックバーの表示状態管理
    const [isSnackbarVisible, setIsSnackbarVisible] = useState(false);

    // 特定条件下では検索条件を非表示にする
    const isHideEmailOption = isDoubleOptIn && isJobAlertSubmitSuccess;

    // スナックバー表示制御
    useEffect(() => {
        if (isDoubleOptIn && isJobAlertSubmitSuccess) {
            setIsSnackbarVisible(true);
            
            const timer = setTimeout(() => {
                setIsSnackbarVisible(false);
            }, 3000);
            
            return () => clearTimeout(timer);
        }
    }, [isDoubleOptIn, isJobAlertSubmitSuccess]);

    return (
        <>
            <JobAlertContainer isInJobPanelList={isInJobPanelList}>
                <div className="p-mail_head">
                    <div className="p-mail_icon">
                        <img src={mix('webfront/images/icon/mail.svg')} width="20" height="16" alt=""/>
                    </div>
                    <h2 className="p-mail_title" dangerouslySetInnerHTML={{__html: jobAlertTranslations.title}}></h2>
                </div>
                {!isHideEmailOption && (
                    <div className="p-mail_option">
                        {jobAlertTranslations.description}: <span className="u-fw_b">{conditionString}</span>
                    </div>
                )}
                <JobAlertForm isInJobPanelList={isInJobPanelList} translations={translations} />
                {isDoubleOptIn ? (
                    <ul className="u-fs13 u-color-gray u-ml15">
                        <li key="daily_send" className="c-list--disc u-mb3">{jobAlertTranslations.double_optin.notice_list.daily_send}</li>
                        <li key="unsubscribe" className="c-list--disc u-mb3">{jobAlertTranslations.double_optin.notice_list.unsubscribe}</li>
                        <li key="agreement" className="c-list--disc u-mb3">
                            {replacePlaceholders(jobAlertTranslations.double_optin.notice_list.agreement, {
                                ":privacy_policy": <a key="privacy_policy" href={route.web.privacy} className="u-link-regular_line u-color-gray">{generalTranslations.privacy_policy}</a>,
                                ":terms_of_service": <a key="terms_of_service" href={route.web.terms} className="u-link-regular_line u-color-gray">{generalTranslations.terms_of_service}</a>,
                            })}
                        </li>
                    </ul>
                ) : (
                    <p className="u-pdt5 u-fs13 u-color-gray">
                        {replacePlaceholders(jobAlertTranslations.single_optin.notice, {
                            ":privacy_policy": <a key="privacy_policy" href={route.web.privacy} className="u-link-regular_line u-color-gray">{generalTranslations.privacy_policy}</a>,
                            ":terms_of_service": <a key="terms_of_service" href={route.web.terms} className="u-link-regular_line u-color-gray">{generalTranslations.terms_of_service}</a>,
                        })}
                    </p>
                )}
            </JobAlertContainer>
            {/* Portalで確実に最上位に表示 - ダブルオプトイン時のみ */}
            {isDoubleOptIn && createPortal(
                <div aria-live="polite">
                    <p 
                        className={`c-alert s-alert ${isSnackbarVisible ? '' : 'is-hide'}`}
                    >
                        <span className="s-alert_message">{jobAlertTranslations.double_optin.snackbar_message}</span>
                    </p>
                </div>,
                document.body
            )}
        </>
    );
};

export default JobAlert;

const JobAlertContainer = ({ isInJobPanelList, children }) => {
    return isInJobPanelList ? (
        <li className="p-mail">
            {children}
        </li>
    ) : (
        <div className="p-mail u-mt40">
            {children}
        </div>
    );
};
